/* eslint-disable camelcase */
import { GACustom } from './types';
import {
  AvailableService,
  AvailableStore,
  NO_STORE_ID,
} from '../Appointment/model';
import { getLocationType, ServiceLocation } from '../../helpers';
import { getService } from '../../helpers/serviceHelper';

export interface CustomParamsForGAEvent {
  postalCode: string;
  step: string;
  options?: {
    serviceId?: string;
    replacementServiceId?: string;
    services?: AvailableService[];
    storeId?: string;
    stores?: AvailableStore[];
  };
}

const transformCustomPartGA = (
  currency: string,
  locationType: ServiceLocation,
): {
  location_type: string;
  currency: string;
} => {
  return {
    location_type: getLocationType(locationType),
    currency,
  };
};

const transformServiceParamsGA = (
  serviceId: string,
  serviceCode: string,
  price: number,
): {
  id: string;
  name: string;
  price: number;
} => {
  return {
    id: serviceCode,
    name: serviceId,
    price,
  };
};

const transformStoreParamsGA = (storeName: string): { store_name?: string } => {
  return storeName.length > 0 ? { store_name: storeName } : {};
};

export const transformToGACustomPayload = ({
  postalCode,
  step,
  options,
}: CustomParamsForGAEvent): GACustom => {
  const { serviceId, replacementServiceId, services, storeId, stores } =
    options || {};
  const service = serviceId && getService(serviceId, services);

  if (!service) {
    return {
      custom: {
        postal_code: postalCode,
        step,
      },
    };
  }

  const { price: priceToUse } =
    replacementServiceId && service.replacementService
      ? service.replacementService.customerPrice
      : service.customerPrice;
  const serviceCodeToUse =
    replacementServiceId && service.replacementService
      ? service.replacementService.serviceCode
      : service.serviceCode;

  const {
    displayPrice: { currencyCode },
    location: locationType,
  } = service;

  const storeName =
    storeId && storeId !== NO_STORE_ID
      ? stores?.find((store) => store.value === storeId)?.text || ''
      : '';

  return {
    custom: {
      postal_code: postalCode,
      step,
      ...transformCustomPartGA(currencyCode, locationType),
      ...transformStoreParamsGA(storeName),
    },
    params: {
      items: [
        {
          quantity: 1,
          ...transformServiceParamsGA(
            replacementServiceId || serviceId,
            serviceCodeToUse,
            priceToUse,
          ),
        },
      ],
    },
  };
};
